const themeProvider = require("./src/layouts/themeProvider")
exports.wrapRootElement = themeProvider
